// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b696fa125588d9e0fa6918cf19d6ffcd0a433dba.chunk.js";
};